<template>
  <div class="HomeLayoutFooterBannerBox" :style="{ position: isScrollBottom ? 'relative' : 'fixed' }">
    <transition name="el-zoom-in-bottom">
      <div class="LibLayoutFooterBanner" v-show="fixedBottom" @click="goLogin">
        <div class="foot-img-box"></div>
        <div class="foot-banner-box">
          <div class="immediately-login" >点击登录</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { DEED_MAP, OID_MAP } from "../../utils/constants/constants.track";

export default {
  name: "LibLayoutFooterBanner",
  props: {
    successGoUrl: {
      //登录后的跳转配置
      type: Object,
      default: () => {
        return {
          type: "href",
          url: "/",
        };
      },
    },
    oidType: {
      //埋点记录来源页
      type: String,
      default: "",
    },
    titleDescribe: {
      //立即登录描述
      type: String,
      default: "查看完整搜索结果",
    },
  },
  data() {
    return {
      fixedBottom: true,
      timeOut: null,
      scrollTop: 0,
      isScrollBottom: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    goLogin() {
      this.$track(DEED_MAP.CLICK, OID_MAP.BOTTOM_BANNER_LOGIN_BTN_CLICK, {
        extendinfo: this.oidType,
      });

      this.$store.commit("basic/updateIsShowDialogLogin", true);
      this.$store.commit("basic/updateLoginSuccessGo", { type: this.successGoUrl.type, url: this.successGoUrl.url });
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let docEl = document.documentElement;
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      let docELHeight = docEl.scrollHeight - 75;
      // 页面上滚动到底部的条件   注意: 滑动距离要加上底通栏的高度，才能保证划到底通栏的时候能正常展示
      if (this.scrollTop >= docELHeight - clientHeight) {
        // 页面内已经滚动的距离 = 页面中内容的总高度 - 浏览器可视部分的高度
        this.fixedBottom = true;
        this.isScrollBottom = true;
        return;
      }
      this.isScrollBottom = false;
      this.fixedBottom = false;
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      this.timeOut = setTimeout(() => {
        this.fixedBottom = true;
      }, 1000);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config.scss";

.HomeLayoutFooterBannerBox {
  width: 100%;
  min-width: $layout-body-width;
  height: 75px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;

  .LibLayoutFooterBanner {
    background-color: #edf0fe;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: relative;

    .foot-banner-box {
      width: 1200px;
      height: 120px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;

      .immediately-login {
        position: absolute;
        bottom: 20px;
        left: 622px;
        margin: auto;
        width: 101px;
        height: 32px;
        background-color: #04c8c2;
        border-radius: 16px;
        border: 1px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #fff;
        font-size: 16px;
        font-weight: $font-weight-Medium;
      }

      .immediately-login:hover {
        background-color: #06e4de;
      }
    }

    .foot-img-box {
      height: 120px;
      background: url("../../assets/img/home-footer-banner/HomeLayoutFooterBanner-content.png") no-repeat center;
      background-size: 1440px 120px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }

    //.title {
    //  font-size: 21px;
    //  font-family: PingFang SC, PingFang SC-Semibold;
    //  font-weight: 550;
    //  text-align: center;
    //  color: #2a2b32;
    //  line-height: 29px;
    //  text-shadow: 0px -2px 20px 0px rgba(14, 34, 93, 0);
    //  padding-top: 25px;
    //  margin-bottom: 16px;
    //
    //  span {
    //    color: $theme-color;
    //  }
    //}
    //
    //.btn {
    //  width: 116px;
    //  height: 28px;
    //  line-height: 28px;
    //  background: $theme-color;
    //  border-radius: 24px;
    //  box-shadow: 0px -2px 20px 0px rgba(14, 34, 93, 0);
    //  font-size: 14px;
    //  font-family: PingFang SC, PingFang SC-Semibold;
    //  font-weight: 550;
    //  text-align: center;
    //  color: #ffffff;
    //  text-shadow: 0px -2px 20px 0px rgba(14, 34, 93, 0);
    //  cursor: pointer;
    //
    //  &:hover {
    //    background-color: #f66d59;
    //  }
    //}

    //.img-box {
    //  font-size: 16px;
    //  font-family: PingFang SC, PingFang SC-Regular;
    //  text-align: left;
    //  color: #45464a;
    //  line-height: 22px;
    //  text-shadow: 0px -2px 20px 0px rgba(14, 34, 93, 0);
    //  display: flex;
    //  align-items: center;
    //  margin-top: 22px;
    //
    //  img {
    //    display: block;
    //    width: 85px;
    //  }
    //
    //  & > div {
    //    display: flex;
    //    align-items: center;
    //  }
    //
    //  .img-item {
    //    display: flex;
    //    margin: 0 6px;
    //    box-shadow: 0px 0px 15px 0px rgba(5, 35, 97, 0.15);
    //  }
    //}
  }
}
</style>
